const SWEEP_ORG_UUIDS = ["ALsGHYnIEi", "KPBOM-EVXo"];

export const isSweepOrg = (orgUuid: string | undefined): boolean => {
  if (!orgUuid) return false;
  return SWEEP_ORG_UUIDS.includes(orgUuid);
};
